import classNames from 'clsx';

import React, { useEffect, useState } from 'react';
import { Button, message, Switch, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import TextArea from 'antd/es/input/TextArea';
import { setKeyWordListStatus, fetchKeyWordList, saveKeyWordList, updateKeyWordList, wrapRequest } from '@/api/subtitles';
import lStyles from './style.module.less';
import styles from '@/components/style/index.module.less';

const App: React.FC = () => {
  const [nounId, setNounId] = useState<string | undefined>('init');
  const [isEdit, setIsEdit] = useState(true);
  const [words, setWords] = useState('');
  const [status, setStatus] = useState<'ON' | 'OFF'>('OFF'); // ON, OFF

  const { t } = useTranslation();
  // const [messageApi, contextHolder] = message.useMessage();
  const [error, setError] = useState<string | null>(null);
  const [succ, setSucc] = useState<string | null>(null);
  const [loadStatus, setLoadStatus] = useState({ open: false, close: false });

  useEffect(() => {
    if (!error) return;
    message.error(error, 5, () => {
      setError(null);
    });
  }, [error]);

  useEffect(() => {
    if (!succ) return;
    message.success(succ, 5, () => {
      setSucc(null);
    });
  }, [succ]);


  async function openKeyWords() {
    setLoadStatus((prevLoad) => ({ ...prevLoad, open: true }));
    if (!nounId) return;
    const { code, data: res } = await wrapRequest(setKeyWordListStatus, { noun_id: nounId, frequency_status_enum: 'ON' });
    if (code !== 'succ' || !res) {
      setError(t('ErrorsetKeyWordListStatus'));
    } else {
      setStatus('ON');
    }
    setLoadStatus((prevLoad) => ({ ...prevLoad, open: false }));
  }

  const getKeyWords = async () => {
    const { code, data: res } = await wrapRequest(fetchKeyWordList, {});

    if (code !== 'succ' || !res) {
      setError(t('ErrorfetchKeyWords'));
      return;
    }
    // succ
    if (res.data.noun_id) {
      // 创建list
      setNounId(res.data.noun_id);
      setWords(res.data.noun_list/* .map(item => item.replace(/\(.*\)/g, '').trim()) */.filter((item) => item !== '').join('\n'));
      setStatus(res.data.frequency_status);
      return;
    }
    const { code: code2, data: res2 } = await wrapRequest(saveKeyWordList, { noun_list: [''] });
    if (code2 !== 'succ' || !res2) {
      setError(t('ErrorfetchKeyWords'));
      return;
    }
    const { code: code3, data: res3 } = await wrapRequest(fetchKeyWordList, {});
    if (code3 !== 'succ' || !res3) {
      setError(t('ErrorfetchKeyWords'));
      return;
    }
    setNounId(res3.data.noun_id);
    setWords(res3.data.noun_list/* .map(item => item.replace(/\(.*\)/g, '').trim()) */.filter((item) => item !== '').join('\n'));
    setStatus(res3.data.frequency_status);
  };

  async function closeKeyWords() {
    if (!nounId) return;
    setLoadStatus((prevLoad) => ({ ...prevLoad, close: true }));
    const { code, data: res } = await wrapRequest(setKeyWordListStatus, { noun_id: nounId, frequency_status_enum: 'OFF' });
    if (code !== 'succ' || !res) {
      setError(t('ErrorcloseKeyWords'));
    } else {
      setStatus('OFF');
    }
    setLoadStatus((prevLoad) => ({ ...prevLoad, close: false }));
  }

  async function updateKeyWords(nounList: string[]) {
    // let nounList: string[] = keyWords.map(kw => kw.word.trim()).filter(word => word !== '');
    if (!nounId) return;
    if (!nounList.length) {
      nounList = [''];
    }
    const { code, data: res } = await wrapRequest(updateKeyWordList, { noun_id: nounId, noun_list: nounList });
    if (code !== 'succ' || !res) {
      console.log('>>>> error', code);
      if (code === 'fail') {
        setError(t('ErrorupdateKeyWords'));
      } else {
        setError(t(code));
      }
    } else {
      setSucc(t('keyWordUpdateSuccess'));
    }
    return code === 'succ' ? 200 : 500;
  }

  useEffect(() => {
    getKeyWords();
  }, []);

  const addKeyWord = () => {
    setIsEdit(false);
  };

  async function update() {
    const ls = words.split('\n');
    const nls = ls.map((item) => item.trim()).filter((item) => item !== '');
    setIsEdit(true);
    setWords(nls.join('\n'));
    const status = await updateKeyWords(nls);
    if (status !== 200) {
      //  修改失败
      setIsEdit(false);
    } else {
      await getKeyWords();
    }
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    console.log('Change:', e.target.value);
    setWords(e.target.value);
  };

  return (
    <div className={classNames(styles.pageContent, lStyles.pageContent)}>
      <div className={classNames(styles.pageTitle, lStyles.hd_title)}>{t('keyWordList')}
        <div className={lStyles.switch}>
          <Switch
            checked={status === 'ON'}
            loading={loadStatus.close}
            onChange={status === 'ON' ? closeKeyWords : openKeyWords}
          />
        </div>
      </div>
      <div className={styles.translatorlog}>
        <div className={lStyles.hd}>
          {isEdit
            ? <Button disabled={status === 'OFF'} className={lStyles.action} onClick={addKeyWord} > {t('keyWordAdd')} </Button>
            : <Button disabled={!nounId} className={lStyles.action} onClick={update} > {t('keyWordSave')} </Button>}

          <Typography.Title className={lStyles.title} level={5}>{t('keyWordInputWarn')}<br />{t('keyWordInputWarnDesc')}</Typography.Title>
        </div>
        <TextArea rows={30} placeholder={t('keyWordInputHolder')} disabled={isEdit} onChange={onChange} value={words} />
      </div>

    </div>
  );
};

export default App;
